import { render } from "./MobViewProducts.vue?vue&type=template&id=30790801&scoped=true"
import script from "./MobViewProducts.vue?vue&type=script&lang=js"
export * from "./MobViewProducts.vue?vue&type=script&lang=js"

import "./MobViewProducts.vue?vue&type=style&index=0&id=30790801&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30790801"]])

export default __exports__